// value はバックエンド InsightFeedback の POSITIVE_REASONS / NEGATIVE_REASONS と一致させる
export const POSITIVE_REASONS = [
  {
    value: 'matched_my_perspective',
    label: '自分の関心・課題に合っていた',
  },
  {
    value: 'got_new_ideas_or_perspectives',
    label: '新しい視点・気づきがあった',
  },
  {
    value: 'motivated_next_action',
    label: '次の一手を試したくなった',
  },
  {
    value: 'convincing_evidence',
    label: '根拠・出典に納得できた',
  },
  {
    value: 'easy_to_read',
    label: 'わかりやすく、読みやすかった',
  },
] as const;

export const NEGATIVE_REASONS = [
  {
    value: 'not_matched_my_perspective',
    label: '自分の関心・課題に合っていなかった',
  },
  {
    value: 'few_new_ideas_or_perspectives',
    label: 'ありきたりで、既に知っていた',
  },
  {
    value: 'no_next_action',
    label: '次の一手につながらなかった',
  },
  {
    value: 'weak_evidence',
    label: '根拠・出典が弱い、事実が疑わしい',
  },
  {
    value: 'hard_to_read',
    label: 'わかりにくい、読みにくい',
  },
] as const;

export type PositiveReason = (typeof POSITIVE_REASONS)[number]['value'];
export type NegativeReason = (typeof NEGATIVE_REASONS)[number]['value'];
export type FeedbackReason = PositiveReason | NegativeReason;

export const COMMENT_MAX_LENGTH = 500;
